import React from 'react';
import glamorous from 'glamorous';
import { IconClasses, Icon } from '@blueprintjs/core';
import { MENU_ENTRIES } from './constants';

const Prerequisites = ({ onSectionChange }) => {
  return (
    <div>
      <h3>
        PREREQUISITES
      </h3>
      Prior to importing recalls, the user/server <strong>MUST</strong>:
      <glamorous.Ul
        className="pt-list"
        css={{
          listStyle: 'disc',
        }}
      >
        <li>have access to the Internet</li>
        <li>
          have access to the following URLs:
          <glamorous.Ul
            css={{
              listStyle: 'circle',
            }}
          >
            <li>
              manual upload by a user: <a href="https://globalrecalls.oecd.org/#/admin" target="_blank">
              https://globalrecalls.oecd.org/#/admin <Icon iconName={IconClasses.SHARE}/>
            </a>
            </li>
            <li>
              automated upload <i>via</i> a server: <a href="https://globalrecalls.oecd.org/ws/import.xqy"
                                                       target="_blank">
              https://globalrecalls.oecd.org/ws/import.xqy <Icon iconName={IconClasses.SHARE}/>
            </a>
            </li>
          </glamorous.Ul>
        </li>
        <li>own an API key (assigned by the OECD – see section: <a
          onClick={e => onSectionChange(MENU_ENTRIES.apiKey)}>API key</a>)
        </li>
        <li>be able to create compressed files (ZIP format).</li>
      </glamorous.Ul>
    </div>
  );
};

export default Prerequisites;



// WEBPACK FOOTER //
// ./src/views/static/import-documentation/prerequisites.js